<script setup>
const props = defineProps({
  content: String,
  placement: {
    type: String,
    default: 'bottom'
  },
})

const target = ref()
const tooltip = ref()
let timer

const clearTimer = () => clearTimeout(timer)

// 进入目标元素
const targetMouseenter = () => {
  clearTimer()
  tooltip.value.style.display = 'block' // 显示之后才能计算出尺寸

  const { top, left, right, bottom, width, height } = target.value.getBoundingClientRect()
  const { width: tWidth, height: tHeight } = tooltip.value.getBoundingClientRect()
  let tTop = bottom , tLeft = right // 注意，这里赋了默认值

  // 计算top值
  if (['left', 'right'].includes(props.placement)) {
    tTop = top + height / 2 - tHeight / 2
  } if (props.placement === 'top') {
    tTop = top - tHeight
  }

  // 计算left值
  if (['top', 'bottom'].includes(props.placement)) {
    tLeft = left + width / 2 - tWidth / 2
  } if (props.placement === 'left') {
    tLeft = left - tWidth
  }

  // 不能超出浏览器区域
  tTop = Math.min(tTop, window.innerHeight - tHeight)
  tLeft = Math.min(tLeft, window.innerWidth - tWidth)

  // 设置元素坐标
  tooltip.value.style.top = tTop + 'px'
  tooltip.value.style.left = tLeft + 'px'
}

// 移出元素
const mouseleave = () => {
  clearTimer()
  
  timer = setTimeout(() => {
    tooltip.value.style.display = 'none'
  }, 300)
}
</script>

<template>
  <span
    v-if="content"
    class="nio-tooltip-target"
    ref="target"
    @mouseenter="targetMouseenter"
    @mouseleave="mouseleave"
  >
    <slot>
      <nio-icon type="info" up/>
    </slot>
    <nio-teleport>
      <div 
        class="nio-tooltip" 
        ref="tooltip"
        @mouseenter="clearTimer"
        @mouseleave="mouseleave"
        @click="mouseleave"
      >
        {{ content }}
      </div>
    </nio-teleport>
  </span>
</template>

<style lang="scss" scoped>
.nio-tooltip {
  @include text-nano;
  display: none;
  width: rem(224);
  padding: rem(20) rem(15);
  line-height: rem(17);
  background-color: #fff;
  position: fixed;
  z-index: 200;
  box-shadow: 0 rem(4) rem(16) rgba(4, 11, 41, 0.05);
}

.nio-icon {
  cursor: pointer;
}
</style>
